var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16 / Canceled-icon",
    clipPath: "url(#clip0_0_27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5 4.50008C14.5 2.84323 13.1569 1.50009 11.5 1.50008L4.50011 1.50002C2.84326 1.50001 1.5001 2.84314 1.50009 4.5L1.50003 11.5C1.50001 13.1568 2.84316 14.5 4.50003 14.5L11.5 14.5C13.1569 14.5 14.5 13.1569 14.5 11.5V4.50008ZM11.6332 10.8668C11.6836 10.9171 11.7235 10.9768 11.7507 11.0426C11.7779 11.1084 11.792 11.1788 11.792 11.25C11.792 11.3212 11.7779 11.3916 11.7507 11.4574C11.7235 11.5232 11.6836 11.5829 11.6332 11.6332C11.5829 11.6836 11.5232 11.7235 11.4574 11.7507C11.3916 11.7779 11.3212 11.792 11.25 11.792C11.1788 11.792 11.1084 11.7779 11.0426 11.7507C10.9768 11.7235 10.9171 11.6836 10.8668 11.6332L8 8.76578L5.13323 11.6332C5.03159 11.7349 4.89374 11.792 4.75 11.792C4.60626 11.792 4.46841 11.7349 4.36677 11.6332C4.26513 11.5316 4.20803 11.3937 4.20803 11.25C4.20803 11.1063 4.26513 10.9684 4.36677 10.8668L7.23422 8L4.36677 5.13323C4.26513 5.03159 4.20803 4.89374 4.20803 4.75C4.20803 4.60626 4.26513 4.46841 4.36677 4.36677C4.46841 4.26513 4.60626 4.20803 4.75 4.20803C4.89374 4.20803 5.03159 4.26513 5.13323 4.36677L8 7.23422L10.8668 4.36677C10.9684 4.26513 11.1063 4.20803 11.25 4.20803C11.3937 4.20803 11.5316 4.26513 11.6332 4.36677C11.7349 4.46841 11.792 4.60626 11.792 4.75C11.792 4.89374 11.7349 5.03159 11.6332 5.13323L8.76578 8L11.6332 10.8668Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.d8de8014196cee33172c40c932f512ce.svg";
export { ForwardRef as ReactComponent };